import AllRoutes from './Allroutes/AllRoutes';
import './App.css';
import Navbar from './page/Navbar';

function App() {
  
  return (
    <>
    <Navbar />
  <AllRoutes />
    </>
  );
}

export default App;
